webpackJsonp([43],{

/***/ 1051:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Forgot_pass_vue__ = __webpack_require__(1159);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dc75ab94_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Forgot_pass_vue__ = __webpack_require__(1232);
function injectStyle (ssrContext) {
  __webpack_require__(1230)
}
var normalizeComponent = __webpack_require__(193)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Forgot_pass_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dc75ab94_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Forgot_pass_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1159:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import api from '../services/service'
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      email: ''
    };
  },

  methods: {
    sendEmail: function sendEmail() {
      this.ToDoDev();
      // this.$store.state.isLoading = true
      // api.forgotPassword(
      //   this.$store.state.URLHost,
      //   { email: this.email },
      //   result => {
      //     if (result.response === 'success') {
      //       this.alert_msg(
      //         'success',
      //         'เปลี่ยนรหัสผ่าน',
      //         result.message
      //       )
      //     } else {
      //       this.alert_msg(
      //         'warning',
      //         'เปลี่ยนรหัสผ่าน',
      //         result.message
      //       )
      //     }
      //     this.$store.state.isLoading = false
      //   },
      //   error => {
      //     this.alert_msg(
      //       'error',
      //       'เปลี่ยนรหัสผ่าน',
      //       'ไม่สามารถเปลี่ยนรหัสผ่าน ได้ เนื่องจาก ' + JSON.stringify(error)
      //     )
      //     console.log(JSON.stringify(error))
      //     this.$store.state.isLoading = false
      //   }
      // )
    }
  }
});

/***/ }),

/***/ 1230:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1231);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1046)("1f343b98", content, true, {});

/***/ }),

/***/ 1231:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1045)(true);
// imports


// module
exports.push([module.i, "body,html{background:#e9ecef}", "", {"version":3,"sources":["/Users/chakritkanpromkad/Developer/maeriminterfood/pos_mis-master/src/views/Forgot_pass.vue"],"names":[],"mappings":"AACA,UAEE,kBAAoB,CACrB","file":"Forgot_pass.vue","sourcesContent":["\nhtml,\nbody {\n  background: #e9ecef;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1232:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"hold-transition lockscreen"},[_c('div',{staticClass:"lockscreen-wrapper"},[_c('div',{staticClass:"lockscreen-logo"},[_c('a',{attrs:{"href":"/"}},[_vm._v(_vm._s(_vm.CompanyConfig.title_web))])]),_vm._v(" "),_c('div',{staticClass:"lockscreen-name"},[_vm._v("Enter your Email")]),_vm._v(" "),_c('div',{staticClass:"lockscreen-item"},[_c('div',{staticClass:"lockscreen-image"},[_c('img',{attrs:{"src":_vm.CompanyConfig.logo_path || '../../static/logo.jpg',"alt":"User Image"}})]),_vm._v(" "),_c('form',{staticClass:"lockscreen-credentials",on:{"submit":function($event){$event.preventDefault();return _vm.sendEmail($event)}}},[_c('div',{staticClass:"input-group"},[_c('input',{staticClass:"form-control",attrs:{"type":"Email","placeholder":"Enter Email ..."}}),_vm._v(" "),_c('div',{staticClass:"input-group-append"},[_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":_vm.sendEmail}},[_c('i',{staticClass:"fas fa-arrow-right text-muted"})])])])])]),_vm._v(" "),_c('div',{staticClass:"help-block text-center"},[_vm._v("\n      Enter your email to reset your password\n    ")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[_c('a',{attrs:{"href":"/login"}},[_vm._v("Or sign in as a different user")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lockscreen-footer text-center"},[_c('strong',[_vm._v("Copyright © "),_c('a',{attrs:{"href":"/"}},[_vm._v("Maeriminterfood Co.,Ltd")]),_vm._v(" 2022 ")]),_c('br'),_vm._v("\n      All rights reserved. "),_c('a',{attrs:{"href":"/"}},[_vm._v("Version")]),_vm._v(" 1.0.0\n    ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/43.b033ef911078165fbf7e.js